import axios from '@/api';

export function getNumberingSettings(competitionId) {
    return axios.get(`competitions/${competitionId}/numbering/settings`);
}

export function updateNumberingSettings(competitionId, payload) {
    return axios.put(`competitions/${competitionId}/numbering/settings`, payload);
}

export function simulateNumbering(competitionId, payload = {}) {
    return axios.post(`competitions/${competitionId}/numbering/simulate`, payload);
}

export function assignNumbering(competitionId, payload) {
    return axios.post(`competitions/${competitionId}/numbering/assign`, payload);
}
